import React, {  useEffect } from "react";

import moment from "moment";
import Grid from "@material-ui/core/Grid";
import { useInvAF, useInvMain } from "../../../St/Reviews/UseStyle";
import {
  Chip,
  colors,
  Container,
  Divider,
  makeStyles,
  Typography,
} from "@material-ui/core";
import tafqeet from "../../../utils/tafqeet";

const useStyles = makeStyles((theme) => ({
  minclr: {
    fontWeight: "bold",
    fontFamily: "Amiri-Regular",
    textAlign: "center",
  },
  txt: {
    fontFamily: "Amiri-Regular",
  },

  BdymtTabl: {
    border: "solid 0.1px",
    borderRadius: "6px",
    marginTop: 10,
  },

  BdymtTabl1: {
    border: "solid 0.1px",
  },
  BdytotTitle: {
    border: "solid 0.1px black",
    borderRadius: "6px",
    textAlign: "center",
    color: "#be151f",
    fontWeight: "bold",
    margin: 2,
  },
  totalItem: {
    padding: 2,
    border: "solid 0px",

    fontFamily: "Amiri-Regular",
  },
}));


 const BodyVochar = (props) => {
    const {infoData}=props;
  const clas = useInvAF();
  const clasm = useInvMain();
  const calssBody = useStyles();
  const secondColor = "#be151f";

  return (
    <Container>
      <Grid
        item
        container
        className={clas.Bdyroot}
        style={{ direction: "rtl", paddingBottom: "5rem" ,fontFamily: "Amiri-Regular", fontWeight:"bold",}}
      >
        <Grid container item xs={12} style={{ paddingTop: "1rem" }}>
          <Grid xs={3} item container>
            <Grid item xs={6} className={calssBody.txt}>
              {"التاريخ"}
            </Grid>
            <Grid item xs={6}>
              <div className={calssBody.minclr}>
                {moment(infoData.Date).format("YYYY/MM/DD")}
              </div>
            </Grid>
            <Grid
              item
              xs={6}
              style={{ paddingTop: 10 }}
              className={calssBody.txt}
            >
              {"طريقة الدفع"}
            </Grid>
            <Grid item xs={6}>
              <Chip
                label={infoData?.auto?.type}
                style={{
                  backgroundColor: colors.green[50],
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  color: secondColor,
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
                className={calssBody.txt}
              />
            </Grid>
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid xs={4} item className={[clas.BdytitleHed]}>
            <div variant="h5" className={clasm.minclr}>
              {infoData.title}
              <Divider
                style={{
                  background: secondColor,
                  height: 1,
                  margin: 5,
                  marginInline: 50,
                }}
              />
            </div>
            <div className={clasm.minclr}>{infoData?.subTitle}</div>
          </Grid>
          <Grid item xs={1}></Grid>

          <Grid
            xs={3}
            item
            container
            style={{
              paddingTop: 10,
              padding: 10,
              direction: "rtl",
              fontFamily: "Amiri-Regular",
               fontWeight:"bold"
               , backgroundColor: colors.green[50],
            }}
          >
            <Grid item xs={6} className={calssBody.txt}>
              {"رقم السند"}
            </Grid>
            <Grid item xs={6}>
              <div className={calssBody.minclr}>
                {infoData.data.id}
              </div>
            </Grid>
            <Grid item xs={12}>
              <Divider
                style={{ background: colors.green[300], height: 1, margin: 5 }}
              />
            </Grid>
            <Grid item xs={6} className={calssBody.txt}>
              {"المبلغ"}
            </Grid>
            <Grid item xs={6}>
              <Typography className={calssBody.minclr}>
                {"#"}
                {infoData.data.val}
                {"#"}
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            container
            style={{ padding: 15 }}
            className={calssBody.BdymtTabl}
          >
            <Grid
              item
              xs={10}
              className={calssBody.txt}
              container
              style={{ fontWeight: "bold" }}
            >
              <Grid item xs={2}>
                {infoData.label + ": "}
              </Grid>
              <Grid item xs={10}>
                {infoData.auto?.custName}
              </Grid>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid
              item
              xs={10}
              container
              className={calssBody.txt}
              style={{ fontWeight: "bold", fontFamily: "Amiri-Regular", paddingTop: 5 }}
            >
              <Grid item xs={2}>
                {"مبلغ وقدرة" + ": "}
              </Grid>
              <Grid item xs={10}>
                {tafqeet(infoData.data.val, "SAR")}

                {"  فقط لا غير  "}
              </Grid>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid
              item
              xs={10}
              container
              className={calssBody.txt}
              style={{ fontWeight: "bold", fontFamily: "Amiri-Regular",paddingTop: 5 }}
            >
              <Grid item xs={2}>
                {"وذلك مقــابل" + ": "}
              </Grid>
              <Grid item xs={10}>
                {infoData.data.notes}
              </Grid>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid
              item
              xs={12}
              container
              className={calssBody.txt}
              style={{ fontWeight: "bold",fontFamily: "Amiri-Regular", paddingTop: 15, paddingBottom: 5 }}
            >
              <Grid item xs={2} style={{ textAlign: "center" }}>
                {"الصندوق / البنك" + ": "}
              </Grid>
              <Grid item xs={10}>
                {infoData.auto.stockName}
              </Grid>
            </Grid>
            {infoData?.data.type != 1 ? (
              <Grid
                item
                container
                xs={12}
                style={{ padding: 15, textAlign: "right", fontWeight: "bold",fontFamily: "Amiri-Regular" }}
                className={calssBody.BdymtTabl1}
              >
                <Grid item container xs={4}>
                  <Grid item xs={4} style={{ textAlign: "center" ,fontWeight:"bold",fontFamily: "Amiri-Regular"}}>
                    {"شيك رقم :"}
                  </Grid>
                  <Grid item xs={8} style={{ textAlign: "center" ,fontWeight:"bold",fontFamily: "Amiri-Regular"}}>
                    {infoData?.data?.check_no}
                  </Grid>
                </Grid>
                <Grid item container xs={4} style={{ textAlign: "center" ,fontWeight:"bold",fontFamily: "Amiri-Regular"}}>
                  <Grid item xs={4} style={{ textAlign: "center" }}>
                    {"تاريخ الشيك"}
                  </Grid>
                  <Grid item xs={8} style={{ textAlign: "center" ,fontWeight:"bold",fontFamily: "Amiri-Regular"}}>
                    {moment(infoData?.data?.check_date).format("YYYY/MM/DD")}
                  </Grid>
                </Grid>
                <Grid item xs={4} container style={{ textAlign: "center" ,fontWeight:"bold",fontFamily: "Amiri-Regular"}}>
                  <Grid item xs={4} style={{ textAlign: "center" ,fontWeight:"bold",fontFamily: "Amiri-Regular"}}>
                    {"على بنك :"}
                  </Grid>
                  <Grid item xs={8} style={{ textAlign: "center" ,fontWeight:"bold",fontFamily: "Amiri-Regular"}}>
                    {infoData.data?.checkbank}
                  </Grid>
                </Grid>
              </Grid>
            ) : null}
            
          </Grid>
          
        </Grid>

        <Grid item container className={clas.BdytotSub}>
          <Grid
            item
            container
            xs={12}
            spacing={1}
            style={{ paddingTop: 50, fontWeight: "bold", textAlign: "center" }}
          >
            <Grid item xs={6} style={{ textAlign: "center" ,fontWeight:"bold",fontFamily: "Amiri-Regular"}}>
              {" "}
              {"محرر السند"}
            </Grid>
            <Grid item xs={6} style={{ textAlign: "center" ,fontWeight:"bold",fontFamily: "Amiri-Regular"}}>
              {" المستلم" + "     " + " Receivr "}
            </Grid>
            <Grid item xs={6} style={{ textAlign: "center" ,fontWeight:"bold",fontFamily: "Amiri-Regular"}}>
              {infoData.auto?.empName}
            </Grid>
            <Grid item xs={6}>
              ____________________
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default BodyVochar;
